// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_ARTICLE = "Naozaj chce\u0161 zmaza\u0165 \u010dl\u00e1nok?";
export const ARTICLE_HAS_BEEN_DELETED = "\u010cl\u00e1nok bol zmazan\u00fd.";
export const EXPLAIN_POST_DELETION = "Zadaj bli\u017e\u0161ie od\u00f4vodnenie:";
